import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { TravelerProfileSetupForm } from '@/features/auth/components/TravelerProfileSetupForm';

export function CompleteProfilePage() {
  const navigate = useNavigate();
  const { setMe, user, postAuthRoute } = useAuth();

  return (
    <Box sx={{ maxWidth: 480, mx: 'auto', py: { xs: 3, md: 5 }, px: 2 }}>
      <Paper elevation={0} sx={{ p: { xs: 2.5, md: 3.5 }, borderRadius: 1.5, border: '1px solid', borderColor: 'divider' }}>
        <TravelerProfileSetupForm
          defaultValues={{
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
          }}
          onSuccess={(data) => {
            const pendingRoute = postAuthRoute;
            setMe({
              ...data,
              postAuthRoute:
                pendingRoute && pendingRoute !== '/' ? pendingRoute : data.postAuthRoute,
            });
            navigate(
              pendingRoute && pendingRoute !== '/'
                ? pendingRoute
                : data.postAuthRoute || '/',
              { replace: true }
            );
          }}
        />
      </Paper>
    </Box>
  );
}
